import React from 'react';
import PropTypes from 'prop-types';
import connectWithStore from '../../hocs/connectWithStore';
import { setUser, setLocale } from './user_actions';

class User extends React.Component {
  constructor(props) {
    super(props);
    props.setUser(props.init.user);
    props.setLocale(props.init.locale);
  }

  render() {
    return (<></>)
  }
}

User.propTypes = {
  setUser: PropTypes.func,
  setLocale: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ...{ user: state.user, locale: state.locale },
});

const mapDispatchToProps = {
  setUser,
  setLocale,
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(User);
